import { mergeSx, type TableCellProps } from '@shared/components';
import type { TableBodyProps, TableHeaderProps } from '@shared/table-generator';

import { EMPTY_CELL_PREFIX, FAILED_CELL_PREFIX } from '../../constants';
import { type CheckType } from '../../types';

export default function getSlotProps(
  type: CheckType,
): [TableHeaderProps['slotProps'], TableBodyProps['slotProps']] {
  const tableHeaderCellProps: TableCellProps = {
    sx: (theme) => ({
      p: theme.spacing(1.5, 2.5),
      borderRadius: theme.shape.rounded(1),
      '&:first-of-type': {
        backgroundColor: theme.palette.grey[700],
        color: theme.palette.common.white,
      },
      minWidth: '60px',
      ...theme.typography.body2Semibold,
    }),
  };

  const tableRowSlotProps: TableCellProps = {
    sx: (theme) => ({
      p: theme.spacing(1.5, 2.5),
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.grey[100],
      borderRadius: theme.shape.rounded(1),
      [`&[id^="${FAILED_CELL_PREFIX}-"]`]: {
        backgroundColor: theme.palette.error.light,
        color: theme.palette.error.dark,
      },
      [`&[id^="${EMPTY_CELL_PREFIX}-"]`]: {
        backgroundColor: theme.palette.grey[300],
      },
      ...theme.typography.body2Semibold,
    }),
  };

  switch (type) {
    case 'DRAFT_TO_DRAFT':
      tableHeaderCellProps.sx = mergeSx(tableHeaderCellProps.sx, (theme) => ({
        backgroundColor: theme.palette.info.light,
        color: theme.palette.info.dark,
      }));
      tableRowSlotProps.sx = mergeSx(tableRowSlotProps.sx, (theme) => ({
        '&:first-of-type': {
          backgroundColor: theme.palette.info.light,
          color: theme.palette.info.dark,
        },
      }));
      break;

    case 'DRAFT_TO_PUBLISHED':
      tableHeaderCellProps.sx = mergeSx(tableHeaderCellProps.sx, (theme) => ({
        backgroundColor: theme.palette.success.light,
        color: theme.palette.success.dark,
      }));
      tableRowSlotProps.sx = mergeSx(tableRowSlotProps.sx, (theme) => ({
        '&:first-of-type': {
          backgroundColor: theme.palette.info.light,
          color: theme.palette.info.dark,
        },
      }));
      break;
    case 'PUBLISHED_TO_PUBLISHED':
      tableHeaderCellProps.sx = mergeSx(tableHeaderCellProps.sx, (theme) => ({
        backgroundColor: theme.palette.success.light,
        color: theme.palette.success.dark,
      }));
      tableRowSlotProps.sx = mergeSx(tableRowSlotProps.sx, (theme) => ({
        '&:first-of-type': {
          backgroundColor: theme.palette.success.light,
          color: theme.palette.success.dark,
        },
      }));
  }

  const columnSlotProps: TableHeaderProps['slotProps'] = {
    tableHeaderCell: tableHeaderCellProps,
  };
  const rowSlotProps: TableBodyProps['slotProps'] = {
    tableBodyCell: tableRowSlotProps,
  };
  return [columnSlotProps, rowSlotProps];
}
